<template>
    <div class="p-3" color="light">
        <h5 class="subtitle-2">
            Machship Webhook
        </h5>
        <v-form
            ref="form"
            v-model="form"
            :disabled="is_disabled">
            <v-container fluid p-0>
                <v-row>
                    <v-col>
                        <p class="mt-3">STATUS: <span v-if="isEnabled" class="text-success">Enabled</span> <span v-else>Disabled</span></p>
                    </v-col>
                    <v-col class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn v-if="isEnabled" color="error" :disabled="isLoading" @click="onDisable">Disable</v-btn>
                        <v-btn v-else color="success" :disabled="isLoading" @click="onEnable">Enable</v-btn>
                    </v-col>
                </v-row>


                <!-- <v-row>
                    <v-col>
                        <v-btn
                            v-if="!subscribe.update.status"
                            type="button"
                            small
                            color="primary"
                            :disabled="isSubmit || subscribe.update.isSubscribing"
                            @click="onSubscribeUpdate">
                            <i v-if="subscribe.update.isSubscribing" class="fa fa-circle-notch fa-spin mr-1"></i>
                            {{ subscribe.update.isSubscribing ? 'Subscribing...' : 'Subscribe update webhook' }}
                        </v-btn>

                        <div v-else>
                            <span>Subscribed to Machship update consignment</span>
                            <v-btn class="ml-3" small color="error" @click="onUnsubscribeUpdate">
                                <i v-if="subscribe.update.isSubscribing" class="fa fa-circle-notch fa-spin mr-1"></i>
                                {{ subscribe.update.isSubscribing ? 'Unsubscribing...' : 'Unsubscribe' }}
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-btn
                            v-if="!subscribe.delete.status"
                            type="button"
                            small
                            color="primary"
                            :disabled="isSubmit || subscribe.delete.isSubscribing"
                            @click="onSubscribeDelete">
                            <i v-if="subscribe.delete.isSubscribing" class="fa fa-circle-notch fa-spin mr-1"></i>
                            {{ subscribe.delete.isSubscribing ? 'Subscribing...' : 'Subscribe delete webhook' }}
                        </v-btn>

                        <div v-else>
                            <span>Subscribed to Machship delete consignment</span>
                            <v-btn class="ml-3" small color="error" @click="onUnsubscribeDelete">
                                <i v-if="subscribe.delete.isSubscribing" class="fa fa-circle-notch fa-spin mr-1"></i>
                                {{ subscribe.delete.isSubscribing ? 'Unsubscribing...' : 'Unsubscribe' }}
                            </v-btn>
                        </div>
                    </v-col>
                </v-row> -->
            </v-container>
        </v-form>
    </div>
</template>
<script>

import { EventBus } from '@/js/event-bus.js'

export default {
    props: {
        is_disabled: { type: Boolean, default: false },
        integrationMeta: { type: Array, default: [] },
        integrationId: { type: String|Number, default: ''  }
    },

    data() {
        return {
            form: null,
            isSubmit: false,
            isLoading: false,
            metaWebhookEnable: null

            // subscribe: {
            //     update: {
            //         isSubscribing: false,
            //         status: false,
            //     },
            //     delete: {
            //         isSubscribing: false,
            //         status: false,
            //     },
            // }
        }
    },

    computed: {
        isEnabled() {
            return this.metaWebhookEnable?.meta_value?.toLowerCase?.() === 'true'
        }
    },

    mounted() {
        // stops if integration meta is empty
        this.metaWebhookEnable = this.integrationMeta[0] ?? null

        // const { event_update, event_delete} = JSON.parse(this.integrationMeta[0].meta_value)


        // console.log("the event update =>", event_update)
        // console.log("the event delete =>", event_delete)

        // // init our subscrib update status
        // this.subscribe.update.status = event_update
        // this.subscribe.delete.status = event_delete
    },

    methods: {

        // For the meantime we only have enable/disable

        async onEnable() {
            if (this.isLoading) {
                return
            }

            this.isLoading = true


            try {

                const { data } = await this.$http.post('api/machship-webhook/enable', {
                    integration_id: this.integrationId
                })

                console.log('[onEnable] success', data.result)
                this.metaWebhookEnable = data.result

                EventBus.$emit('show-success', 'Successfully enabled Machship webhook.')

                this.isLoading = false
            } catch (err) {
                this.isLoading = false
                EventBus.$emit('show-error', err)
            }
        },

        async onDisable() {

            if (this.isLoading) {
                return
            }

            this.isLoading = true

            try {

                const { data } = await this.$http.post('api/machship-webhook/disable', {
                    integration_id: this.integrationId
                })

                console.log('[onDisable] success', data.result)
                this.metaWebhookEnable = data.result

                EventBus.$emit('show-success', 'Successfully disabled Machship webhook.')

                this.isLoading = false

            } catch (err) {
                this.isLoading = false
                EventBus.$emit('show-error', err)
            }
        },


        // Everything Subscribe/Unsubscribe will be commented as this isn't implemented yet

        // onSubscribeUpdate(e) {
        //     e.preventDefault()
        //     const { update } = this.subscribe
        //     this.onSubscribe('event_update', update)

        // },

        // onSubscribeDelete(e) {
        //     e.preventDefault()
        //     this.onSubscribe('event_delete', this.subscribe.delete)

        // },

        // onUnsubscribeUpdate(e) {
        //     e.preventDefault()
        //     const { update } = this.subscribe
        //     this.onUnsubscribe('event_update', update)
        // },

        // onUnsubscribeDelete(e) {
        //     e.preventDefault()
        //     this.onUnsubscribe('event_delete', this.subscribe.delete)
        // },


        // async onSubscribe(event, subscribe) {
        //     const integration_id = this.integrationId

        //     subscribe.isSubscribing = true

        //     const data = {
        //         integration_id,
        //         event
        //     }

        //     const result = await this.$http.post('api/machship-webhook/subscribe', data)

        //     console.log('success', result);
        //     subscribe.isSubscribing = false
        //     subscribe.status = true
        // },

        // async onUnsubscribe(event, subscribe) {
        //     const integration_id = this.integrationId

        //     subscribe.isSubscribing = true

        //     const data = {
        //         integration_id,
        //         event
        //     }

        //     const result = await this.$http.post('api/machship-webhook/unsubscribe', data)

        //     console.log('success', result);
        //     subscribe.isSubscribing = false
        //     subscribe.status = false
        // }
    }


}
</script>